import Swal from 'sweetalert2';
import FeatherIcon from 'feather-icons-react';
import ReactDOMServer from 'react-dom/server';


/**
 * Show a delete confirmation modal.
 * 
 * @param {Object} options
 * @param {string} [options.title] - Title of the modal.
 * @param {string} [options.message] - Message/body text.
 * @param {string} [options.confirmButtonText] - Text for the confirm button.
 * @param {Function} options.onConfirm - Callback executed if confirmed.
 */
export const showDeleteAlert = ({
  title = 'Are you sure?',
  message = 'Do you really want to delete this item?',
  confirmButtonText = 'Yes, Delete It!',
  onConfirm,
  isInfo = false
}) => {
  const htmlContent = ReactDOMServer.renderToString(
    <div style={{ textAlign: 'center' }}>
      <div
        style={{
          width: '100px',
          height: '100px',
          backgroundColor: '#fef4f4',
          borderRadius: '50%',
          margin: '0 auto',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        {
          isInfo ? (<FeatherIcon icon="alert-triangle" size="48" color="#f06548" />) : (<FeatherIcon icon="trash-2" size="48" color="#f06548" />)
        }
        
      </div>
      <h4 style={{ marginTop: '20px' }}>{title}</h4>
      <p className="text-muted">{message}</p>
    </div>
  );

  Swal.fire({
    html: htmlContent,
    showCancelButton: true,
    confirmButtonText,
    cancelButtonText: 'Cancel',
    showCloseButton: true,
    buttonsStyling: false,
    customClass: {
      confirmButton: 'btn btn-primary w-xs me-2 mb-1',
      cancelButton: 'btn btn-danger w-xs mb-1',
    },
  }).then((result) => {
    if (result.isConfirmed && typeof onConfirm === 'function') {
      onConfirm();
    }
  });
};